/**
 * LocalStorage wrapper with type safety and error handling
 */

export const storage = {
  get<T>(key: string): T | null {
    try {
      const item = localStorage.getItem(key);
      if (!item || item === 'undefined' || item === 'null') {
        return null;
      }
      return JSON.parse(item);
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error);
      // Clean up corrupted data
      localStorage.removeItem(key);
      return null;
    }
  },

  set<T>(key: string, value: T): void {
    try {
      if (value === undefined || value === null) {
        localStorage.removeItem(key);
        return;
      }
      localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  },

  remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing localStorage key "${key}":`, error);
    }
  },

  clear(): void {
    try {
      localStorage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  },
};

// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKENS: 'lezzet_yolda_auth_tokens',
  USER_DATA: 'lezzet_yolda_user_data',
  GUEST_ID: 'lezzet_yolda_guest_id',
  GUEST_CART: 'lezzet_yolda_guest_cart',
  GUEST_ORDER_CONFIRMATION: 'lezzet_yolda_guest_order_confirmation',
  GUEST_ORDER_TRACKING_URL: 'lezzet_yolda_guest_order_tracking_url',
  LAST_SERVICE_ZONE: 'lezzet_yolda_last_service_zone',
  USER_LOCATION: 'lezzet_yolda_user_location',
  SERVICE_ZONE_DATA: 'lezzet_yolda_service_zone_data',
  ACTIVE_DELIVERY_ADDRESS: 'lezzet_yolda_active_delivery_address',
  SELECTED_CITY: 'lezzet_yolda_selected_city',
} as const;

// Location cache TTL: 24 hours in milliseconds
export const LOCATION_CACHE_TTL = 24 * 60 * 60 * 1000;
